import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-gradient-to-b from-amber-50 via-amber-50/50 to-white pt-20 pb-16 lg:pt-32 lg:pb-24" data-id="element-87">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-89">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left max-w-2xl mx-auto lg:mx-0" data-id="element-90">
            <span className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-bold bg-amber-100 text-amber-700 mb-6 border border-amber-200 shadow-sm" data-id="element-91">
              📚 Ebook para padres y madres
            </span>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-stone-900 leading-tight mb-6 tracking-tight" data-id="element-92">
              ¿Y si el problema{' '}
              <span className="text-amber-500" data-id="element-93">no fuera tu hijo?</span>
            </h1>

            <p className="text-xl sm:text-2xl text-stone-600 mb-8 font-medium leading-relaxed" data-id="element-94">
              Buenas intenciones. Cuatro repeticiones. Y el grito que no querías
              dar.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start mb-6" data-id="element-95">
              <button onClick={() => document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            })} className="w-full sm:w-auto px-8 py-4 bg-amber-500 hover:bg-amber-600 text-white text-lg font-bold rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 group" data-id="element-96">
                🎯 Descargar Rutinas Visuales
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-97" />
              </button>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-x-6 gap-y-2 text-sm text-stone-500 font-medium" data-id="element-98">
              <span className="flex items-center gap-1.5" data-id="element-99">
                <CheckCircle2 className="w-4 h-4 text-emerald-500" data-id="element-100" />
                Sistema visual paso a paso
              </span>
              <span className="flex items-center gap-1.5" data-id="element-101">
                <CheckCircle2 className="w-4 h-4 text-emerald-500" data-id="element-102" />
                Plantillas imprimibles
              </span>
              <span className="flex items-center gap-1.5" data-id="element-103">
                <CheckCircle2 className="w-4 h-4 text-emerald-500" data-id="element-104" />
                Resultados en 1 semana
              </span>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          rotate: -2
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 relative" data-id="element-105">
            <div className="relative z-10 max-w-sm mx-auto" data-id="element-106">
              <div className="absolute -inset-4 bg-amber-200/50 rounded-full blur-3xl opacity-70 animate-pulse" data-id="element-107"></div>
              <img src="https://cdn.magicpatterns.com/uploads/qhpin6YT7a7eK1bRf1jjZb/rutinas_visuales_portada_de_ebook.png" alt="Portada del libro Rutinas Visuales sin Gritos" className="relative w-full h-auto rounded-xl shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-108" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}